import { useLiqPrice } from '../components/TradeModule/hooks/useLiqPrice';
import { useCollateralToken } from '../components/TradeModule/store/useCollateralToken';
import { useEntryPriceAfterSpread } from './useEntryPriceAfterSpread';
import { usePayTokenPriceLatest } from './usePayTokenPriceLatest';

export const useLiqPriceAfterSpread = () => {
  const entryPrice = useEntryPriceAfterSpread();
  const payToken = useCollateralToken((s) => s.useCollateralTokenValue());
  const payTokenPrice = usePayTokenPriceLatest(payToken);
  const liqPrice = useLiqPrice({
    entryPrice: entryPrice,
    payTokenPrice: payTokenPrice,
  });

  return liqPrice;
};
